module.exports = __webpack_public_path__ + "images/marketing_site/jp_werlin.jpg";